// @flow
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { getActive, getCompleted, getNew } from "./Timer";
import Tournament from "./Tournament";
import Gettext from "../common/Gettext";

import type { MapStateToProps } from "react-redux";
import type { Tournament as TournamentItem } from "../../redux/CommonTypes";

const TournamentTitle = styled.div`
  width: 100%;
  min-width: 100%;
  margin-top: 5px;
  margin-bottom: 30px;
  font-size: 18px;
  font-weight: bold;
  color: #bebebe;
  line-height: 1.2;

  @media (max-width: 969px) {
    min-width: auto;
    max-width: 463px;
    margin-top: 0;
    margin-bottom: 25px;
  }
`;

type Props = {
  data: {
    status: "OK" | "ERROR",
    value: {
      count: number,
      items: Array<TournamentItem>
    }
  },
  apiParams: string,
  time: string
};

const freeForUser = tournament => {
  return !!(
    (tournament.type === "free" && tournament.subtype !== "demo") ||
    (tournament.is_limited && tournament.invited)
  );
};

function ActiveTournaments(props: Props) {
  const tournaments = props.data.value != null ? props.data.value.items : [];
  const tournamentsByType = () => {
    switch (props.type) {
      case "free":
        return tournaments.filter(tournament => freeForUser(tournament));
      case "paid":
        return tournaments.filter(tournament => !freeForUser(tournament));
      default:
        return tournaments;
    }
  };

  const participatingTournaments = tournamentsByType().filter(
    tournament => tournament.participation_status === 1
  );
  const otherTournaments = tournamentsByType().filter(
    tournament => tournament.participation_status === 0
  );

  const { time } = props;

  switch (true) {
    case tournamentsByType().length === 0:
      return (
        <div
          style={{
            margin: "10px auto",
            paddingBottom: 10,
            textAlign: "center"
          }}
        >
          <Gettext>There are no tournaments available.</Gettext>
        </div>
      );
    case participatingTournaments.length > 0:
      return (
        <React.Fragment>
          <TournamentTitle>
            {props.isCompleted ? (
              <Gettext>You have participated</Gettext>
            ) : (
              <Gettext>You are participating</Gettext>
            )}
          </TournamentTitle>
          {participatingTournaments.map((item, i) => (
            <Tournament
              active={getActive({ ...item, time })}
              isCompleted={getCompleted({ ...item, time })}
              isNew={getNew({ ...item, time })}
              isLimited={item.is_limited}
              isLimitedForMoney={item.limited_for_money}
              type={item.type}
              title={item.title}
              prize_fund={item.prize_fund_usd}
              userPlace={item.current_place}
              participantsCount={item.participant_count}
              participation_status={item.participation_status}
              key={i}
              id={item.id}
              apiParams={props.apiParams}
              dispatch={props.dispatch}
              onActivateTournament={props.onActivateTournament}
              onActiveTradeClick={props.onActiveTradeClick}
              onClick={props.onClick}
              popupCallback={props.popupCallback}
              time={time}
              {...item}
            />
          ))}
          {otherTournaments.length > 0 && (
            <React.Fragment>
              <TournamentTitle>
                <Gettext>Other tournaments</Gettext>
              </TournamentTitle>
              {otherTournaments.map((item, i) => (
                <Tournament
                  active={getActive({ ...item, time })}
                  isCompleted={getCompleted({ ...item, time })}
                  isNew={getNew({ ...item, time })}
                  isLimited={item.is_limited}
                  isLimitedForMoney={item.limited_for_money}
                  type={item.type}
                  title={item.title}
                  prize_fund={item.prize_fund_usd}
                  userPlace={item.current_place}
                  participantsCount={item.participant_count}
                  participation_status={item.participation_status}
                  key={i}
                  id={item.id}
                  apiParams={props.apiParams}
                  dispatch={props.dispatch}
                  onActivateTournament={props.onActivateTournament}
                  onActiveTradeClick={props.onActiveTradeClick}
                  onClick={props.onClick}
                  popupCallback={props.popupCallback}
                  time={time}
                  {...item}
                />
              ))}
            </React.Fragment>
          )}
        </React.Fragment>
      );
    default:
      return tournamentsByType().map((item, i) => (
        <Tournament
          active={getActive({ ...item, time })}
          isCompleted={getCompleted({ ...item, time })}
          isNew={getNew({ ...item, time })}
          isLimited={item.is_limited}
          isLimitedForMoney={item.limited_for_money}
          type={item.type}
          title={item.title}
          prize_fund={item.prize_fund_usd}
          userPlace={item.current_place}
          participantsCount={item.participant_count}
          participation_status={item.participation_status}
          key={i}
          id={item.id}
          apiParams={props.apiParams}
          dispatch={props.dispatch}
          onActivateTournament={props.onActivateTournament}
          onActiveTradeClick={props.onActiveTradeClick}
          onClick={props.onClick}
          popupCallback={props.popupCallback}
          time={time}
          {...item}
        />
      ));
  }
}

export default connect(
  (state => ({
    time: state.time || Date.now()
  }): MapStateToProps<*, *, *>)
)(ActiveTournaments);



// WEBPACK FOOTER //
// ./src/components/Tournaments/ActiveTournaments.js